<template>
	<div class="scrollable-wrappers">
		<div class="button_filter_container" v-if="needScroll && canScrollLeft">
			<v-btn icon class="scroll-button" @click="moveLeft" color="#002855">
				<Icon type="chevron_left" :size="14" />
			</v-btn>
		</div>
		<div class="scrollable-container" ref="scrollContainer">
			<div
				class="scrollable-content"
				:style="{
					transform: `translateX(${translateX}px)`,
					paddingRight: `${rightPadding}px`,
				}"
			>
				<v-btn
					v-for="chipItem in normalizedFeedFilterChips"
					:key="chipItem.name"
					@click="getAndCallDynamicFunction(getChipName(chipItem))"
					class="filter-chip-button"
					:class="{
						'filter-chip-button-active': isButtonActive(getChipName(chipItem)),
					}"
				>
					<v-icon
						@click.stop="clearFilter(getChipName(chipItem))"
						v-if="
							isButtonActive(getChipName(chipItem)) &&
							getChipName(chipItem) !== 'clear'
						"
					>
						mdi-close
					</v-icon>
					{{ getChipLabel(chipItem) }}
				</v-btn>
			</div>
		</div>
		<div class="button_filter_container_left" v-if="needScroll && !scrollRightStop">
			<v-btn icon class="scroll-button" @click="moveRight">
				<Icon type="chevron_right" :size="14" color="#002855" />
			</v-btn>
		</div>
	</div>
</template>

<script>
import { scrollChipMixin } from '@/mixins/ScrollChipMixin'

export default {
	name: 'FilterChipButton',
	props: {
		useContentAsKey: {
			type: Boolean,
			default: false,
		},
		isButtonActive: {
			type: Function,
			required: true,
		},
		normalizedFeedFilterChips: {
			type: Array,
			default: () => [],
		},
		getAndCallDynamicFunction: {
			type: Function,
			required: true,
		},
		clearFilter: {
			type: Function,
			required: true,
		},
	},
	mixins: [scrollChipMixin],
	mounted() {
		window.addEventListener('resize', this.handleResize)
		this.$nextTick(this.updateScrollState)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	},
}
</script>

<style lang="scss">
.scrollable-wrappers {
	display: flex;
	align-items: baseline !important;
	width: 600px;
	@media (max-width: 480px) {
		flex-direction: column;
		align-items: flex-start;
		height: unset !important;
	}
}

.button_filter_container,
.button_filter_container_left {
	@media (max-width: 480px) {
		display: none;
	}
}

.scrollable-container {
	overflow: hidden;
	flex-grow: 0;

	@media (max-width: 480px) {
		overflow: visible;
		width: 100%;
	}
}

.scrollable-content {
	display: flex;
	gap: 12px;
	transition: transform 0.3s ease, padding-right 0.3s ease;

	@media (max-width: 480px) {
		flex-wrap: wrap;
		transform: none !important;
		padding-right: 0 !important;
	}
}

.filter-chip-button {
	margin-top: 1px;
	color: var(--chip-text-normal) !important;
	font-size: 14px;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
	letter-spacing: 0.36px;
	background-color: var(--chip-normal-background) !important;
	border-radius: 15px;
	box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
	text-transform: capitalize !important;
	align-items: center;

	&-active {
		background-color: var(--chip-selected-background) !important;
		color: var(--chip-text-selected) !important;
	}
}
</style>
